import React, { Component } from 'react';
import NavBarInverted from '../../components/nav/NavBarInverted.component.jsx';
import FooterLarge from '../../components/footer/FooterLarge.jsx';
import AutismArticlesCards from './AutismArticlesCards';
import aut from '../../assets/images/illustrations/autism-what.png';
import causes_png from '../../assets/images/illustrations/autism-causes.png';
import diagnosis_png from '../../assets/images/illustrations/autism-diagnosis.png';
import symptoms_png from '../../assets/images/illustrations/autism-symptoms.png';
import treatment_png from '../../assets/images/illustrations/autism-treatment.png';
import causes from '../../assets/images/Autism-webp/Causes/05_causes_R01.webp';
import diagnosis from '../../assets/images/Autism-webp/Diagnosing/06_diagnosingAutism_R03@3x.webp';
import symptoms from '../../assets/images/Autism-webp/Symptoms/05_symptoms_R01@3x.webp';
import treatment from '../../assets/images/Autism-webp/Treatment/06_autismTreatment_R01@3x.webp';
import aut_small from '../../assets/images/illustrations/smaller-autism-images/width-100/autism-what.png';
import causes_small from '../../assets/images/illustrations/smaller-autism-images/width-100/autism-causes.png';
import diagnosis_small from '../../assets/images/illustrations/smaller-autism-images/width-100/autism-diagnosis.png';
import symptoms_small from '../../assets/images/illustrations/smaller-autism-images/width-100/autism-symptoms.png';
import treatment_small from '../../assets/images/illustrations/smaller-autism-images/width-100/autism-treatment.png';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FooterHover from '../../components/footer/FooterHover.jsx';
import What from './tabs/What';
import Symptoms from './tabs/Symptoms';
import Diagnosys from './tabs/Diagnosys';
import Reason from './tabs/Reason';
import Cure from './tabs/Cure';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component={'div'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `scrollable-prevent-tab-${index}`,
        'aria-controls': `scrollable-prevent-tabpanel-${index}`,
    };
}
//   const useStyles = makeStyles((theme) => ({
//     root: {
//       flexGrow: 1,
//       width: '100%',
//       backgroundColor: theme.palette.background.paper,
//     },
//   }));
class Autism extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: 0,
            imageLoaded: false,
            sheet: [],
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (i18next.language === 'ar') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'ar');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
            document.getElementById('root').style.textAlign = 'right';
            document.getElementById('root').dir = 'rtl';
        } else if (i18next.language === 'en') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
            document.getElementById('root').style.textAlign = 'left';
            document.getElementById('root').dir = 'ltr';
        }
    }
    handleChange = (e, v) => {
        this.setState({
            value: v,
            imageLoaded: false,
        });
    };

    handleImageLoad = () => {
        this.setState({
            imageLoaded: true,
        });
        console.log('finish loading!');
    };

    render() {
        const { t } = this.props;
        const { value } = this.state;

        let autism = <AutismArticlesCards articles={this.props.articles} />;

        return (
            <div>
                <div className='autism-container'>
                    <NavBarInverted big autism />
                    <div
                        className={`autism-page ${
                            i18next.language === 'en'
                                ? 'ltr text-left en-autism-page'
                                : ''
                        }`}
                    >
                        <div className='autism-info-wrapper'>
                            <div className='towd'>
                                <h1>{t('autism.title')}</h1>

                                <AppBar position='static'>
                                    <Tabs
                                        value={value}
                                        onChange={this.handleChange}
                                        variant='scrollable'
                                        scrollButtons='off'
                                        aria-label='scrollable prevent tabs example'
                                    >
                                        <Tab
                                            label={`${t('autism.tabs.what')}`}
                                            {...a11yProps(0)}
                                        />
                                        <Tab
                                            label={`${t(
                                                'autism.tabs.symptoms'
                                            )}`}
                                            {...a11yProps(1)}
                                        />
                                        <Tab
                                            label={`${t(
                                                'autism.tabs.diagnosys'
                                            )}`}
                                            {...a11yProps(2)}
                                        />
                                        <Tab
                                            label={`${t(
                                                'autism.tabs.reasons'
                                            )}`}
                                            {...a11yProps(3)}
                                        />
                                        <Tab
                                            label={`${t('autism.tabs.cure')}`}
                                            {...a11yProps(4)}
                                        />
                                    </Tabs>
                                    {/* <div class='fadedScroller_tabs'></div> */}
                                </AppBar>
                            </div>

                            <div className='left-side oned'>
                                <TabPanel value={value} index={0}>
                                    <img
                                        src={aut}
                                        alt='holder'
                                        className='autism-page-img autism-image-noblur autism-image-what'
                                        style={{
                                            display: `${
                                                this.state.imageLoaded
                                                    ? 'block'
                                                    : 'none'
                                            }`,
                                        }}
                                        onLoad={() => this.handleImageLoad()}
                                    />

                                    {!this.state.imageLoaded && (
                                        <img
                                            src={aut_small}
                                            alt='holder'
                                            className='autism-page-img autism-image-blur autism-image-what'
                                        />
                                    )}
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    <picture>
                                        <source
                                            srcSet={symptoms_png}
                                            type='image/png'
                                        />
                                        <source
                                            srcSet={symptoms}
                                            type='image/webp'
                                        />
                                        <img
                                            src={symptoms}
                                            alt='holder'
                                            className='autism-page-img autism-image-noblur autism-image-symptoms'
                                            style={{
                                                display: `${
                                                    this.state.imageLoaded
                                                        ? 'block'
                                                        : 'none'
                                                }`,
                                            }}
                                            onLoad={() =>
                                                this.handleImageLoad()
                                            }
                                        />
                                    </picture>

                                    {!this.state.imageLoaded && (
                                        <img
                                            src={symptoms_small}
                                            alt='holder'
                                            className='autism-page-img autism-image-blur autism-image-symptoms'
                                        />
                                    )}
                                </TabPanel>
                                <TabPanel value={value} index={2}>
                                    <picture>
                                        <source
                                            srcSet={diagnosis_png}
                                            type='image/png'
                                        />
                                        <source
                                            srcSet={diagnosis}
                                            type='image/webp'
                                        />
                                        <img
                                            src={diagnosis}
                                            alt='holder'
                                            className='autism-page-img autism-image-noblur autism-image-symptoms'
                                            style={{
                                                display: `${
                                                    this.state.imageLoaded
                                                        ? 'block'
                                                        : 'none'
                                                }`,
                                            }}
                                            onLoad={() =>
                                                this.handleImageLoad()
                                            }
                                        />
                                    </picture>
                                    {!this.state.imageLoaded && (
                                        <img
                                            src={diagnosis_small}
                                            alt='holder'
                                            className='autism-page-img autism-image-blur autism-image-symptoms'
                                        />
                                    )}
                                </TabPanel>
                                <TabPanel value={value} index={3}>
                                <picture>
                                        <source
                                            srcSet={causes_png}
                                            type='image/png'
                                        />
                                        <source
                                            srcSet={causes}
                                            type='image/webp'
                                        />
                                        <img
                                        src={causes}
                                        alt='holder'
                                        className='autism-page-img autism-image-noblur autism-image-symptoms'
                                        style={{
                                            display: `${
                                                this.state.imageLoaded
                                                    ? 'block'
                                                    : 'none'
                                            }`,
                                        }}
                                        onLoad={() => this.handleImageLoad()}
                                    />
                                    </picture>
                                     
                                    {!this.state.imageLoaded && (
                                        <img
                                            src={causes_small}
                                            alt='holder'
                                            className='autism-page-img autism-image-blur autism-image-symptoms'
                                        />
                                    )}
                                </TabPanel>
                                <TabPanel value={value} index={4}>
                                <picture>
                                        <source
                                            srcSet={treatment_png}
                                            type='image/png'
                                        />
                                        <source
                                            srcSet={treatment}
                                            type='image/webp'
                                        />
                                         <img
                                        src={treatment}
                                        alt='holder'
                                        className='autism-page-img autism-image-noblur autism-image-symptoms'
                                        style={{
                                            display: `${
                                                this.state.imageLoaded
                                                    ? 'block'
                                                    : 'none'
                                            }`,
                                        }}
                                        onLoad={() => this.handleImageLoad()}
                                    />
                                    </picture>
                                   
                                    {!this.state.imageLoaded && (
                                        <img
                                            src={treatment_small}
                                            alt='holder'
                                            className='autism-page-img autism-image-blur autism-image-symptoms'
                                        />
                                    )}
                                </TabPanel>
                            </div>
                            <div
                                class={`threed ${
                                    i18next.language === 'en'
                                        ? 'ltr text-left'
                                        : ''
                                }`}
                            >
                                <div className='autism-views'>
                                    <TabPanel value={value} index={0}>
                                        <What />
                                    </TabPanel>
                                </div>
                                <div className='autism-views'>
                                    <TabPanel value={value} index={1}>
                                        <Symptoms />
                                    </TabPanel>
                                </div>
                                <div className='autism-views'>
                                    <TabPanel value={value} index={2}>
                                        <Diagnosys />
                                    </TabPanel>
                                </div>
                                <div className='autism-views'>
                                    <TabPanel value={value} index={3}>
                                        <Reason />
                                    </TabPanel>
                                </div>
                                <div className='autism-views'>
                                    <TabPanel value={value} index={4}>
                                        <Cure />
                                    </TabPanel>
                                </div>
                            </div>
                            {/* <div class='fadedScroller_fade'></div> */}
                        </div>
                        <div className='related-container'>
                            <h1 class='title'>{t('related')}</h1>
                            <div className='articles-cards'>
                                <AutismArticlesCards
                                    articles={this.props.articles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <FooterLarge minimal />
                <FooterHover />
            </div>
        );
    }
}

export default withTranslation()(Autism);
